module.exports = __webpack_public_path__ + "img/VOL.d97dad9.svg";